import React from 'react';

import {ClearSearchButtonProps} from 'search/ClearSearchButton';
import ListingFiltersContainer from 'search/filters/ListingFiltersContainer';
import {Filter, FilterErrors, FilterKey} from 'search/SearchConstants';

import {WorkflowTemplate} from './WorkflowConstants';

interface WorkflowsFiltersContainerProps {
  filters: Array<Filter>;
  filterErrors: FilterErrors;
  onChangeFilters: (filters: Array<Filter>) => void;
  workflowTemplates: Array<WorkflowTemplate> | null;
  clearButton?: React.ReactElement<ClearSearchButtonProps> | null;
}

const WorkflowsFiltersContainer: React.SFC<WorkflowsFiltersContainerProps> = (
  props: WorkflowsFiltersContainerProps
): JSX.Element => (
  <ListingFiltersContainer
    primaryFilterOptions={[
      {filterKey: FilterKey.WORKFLOW_TEMPLATE},
      {filterKey: FilterKey.AUTHOR},
      {filterKey: FilterKey.WORKFLOW_STATUS},
    ]}
    filters={props.filters}
    filterErrors={props.filterErrors}
    onChangeFilters={(filters) => {
      props.onChangeFilters(filters);
    }}
    selectedSchema={null}
    clearButton={props.clearButton}
  />
);

export default WorkflowsFiltersContainer;
